import { render, staticRenderFns } from "./selectMaterial.vue?vue&type=template&id=2c05d8fe&scoped=true"
import script from "./selectMaterial.vue?vue&type=script&lang=js"
export * from "./selectMaterial.vue?vue&type=script&lang=js"
import style0 from "./selectMaterial.vue?vue&type=style&index=0&id=2c05d8fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c05d8fe",
  null
  
)

export default component.exports